'use client'

import { useQuery } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'

import { roomQueries } from '@/entities/room'
import { Link } from '@/shared/i18n'
import { InnerLayout, OuterLayout, TextButton } from '@/shared/ui'

import { WideCarousel } from '../carousel'
import { RoomCard } from './room-card'

export const RecentViewedRooms = () => {
  const t = useTranslations('recent_room')

  const { data } = useQuery({
    ...roomQueries.recentViewedRoomsWithPagination({ page: 1, size: 10 }),
    meta: { useCustomHandling: true },
  })

  const rooms = data?.content ?? []

  if (rooms.length === 0) return null

  return (
    <section className="mb-20">
      <OuterLayout className="mb-10 flex">
        <InnerLayout className="relative my-0">
          <h3 className="typo-title2 text-center font-semibold text-black">
            {t('title')}
          </h3>
          <TextButton
            size="small"
            color="gray"
            asChild
            className="absolute top-1/2 right-0 -translate-y-1/2"
          >
            <Link href="/guest/my/recent-room">{t('view_all')}</Link>
          </TextButton>
        </InnerLayout>
      </OuterLayout>
      <WideCarousel.Root options={{ slidesToScroll: 3 }} showDots={false}>
        {rooms.map(room => (
          <WideCarousel.Item key={room.rid} className="pl-[15px]">
            <RoomCard {...room} />
          </WideCarousel.Item>
        ))}
      </WideCarousel.Root>
    </section>
  )
}
